/**
 * Frontend-only entry (opens the project picker). Not an API agent — labels stay local until
 * a backend agent or customization endpoint exists.
 */
// eslint-disable-next-line i18next/no-literal-string -- agent id, matched by the backend shortcut allow-list; the rendered title comes from a separate lookup
export const ADAPTATION_AGENT_ID = 'Adaptation';
